import { render, staticRenderFns } from "./layout-2023.vue?vue&type=template&id=32659497&"
var script = {}
import style0 from "./layout-2023.vue?vue&type=style&index=0&id=32659497&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.7.3_vue-template-compiler@2.6.14_webpack@5.81.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports